export const MAX_PASSWORD_LENGTH = 99;
export const MIN_PASSWORD_LENGTH = 12;
export const MIN_PASSWORD_LENGTH_LABEL = `Please use at least ${MIN_PASSWORD_LENGTH} characters`;

// Regex taken from  https://stackoverflow.com/questions/58767980/aws-cognito-password-regex
// @todo implement Enable Us password policy regex
export const PASSWORD_REGEX =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{12,256}$/;

export const PASSWORD_LENGTH_REGEX_STR = `.{${MIN_PASSWORD_LENGTH},99}`;
export const PASSWORD_LENGTH_REGEX = new RegExp(PASSWORD_LENGTH_REGEX_STR);

export const PASSWORD_RULES = ['required', 'passwordLengthConstraint'].join(
  '|'
);
